import React from "react";
import styles from './Banner.module.css';

const Banner = () => {

  return (
    <>
        <div className={styles.imgbox}>
            <div className={`${styles.center} overflow-hidden`}>
                <p data-aos='fade-down' className={styles.text}>Expert Guidance You Trust</p>
                <p data-aos='fade-down' className={styles.text}> Unmatched Service You Can Rely. </p>
               
                {/* <button data-aos='fade-up' className={`btn custom_btn ${styles.btn}`}>Free Consultation</button> */}
            </div>
            
        </div>
        
    </>
  );
};

export default Banner;
